import { SxProps } from '@mui/material'

interface TooltipStyles {
  root: SxProps
  arrow: SxProps
}

export const tooltipStyles: TooltipStyles = {
  root: {
    typography: 'textXsMedium',
    bgcolor: 'utils.gray950',
    color: 'text.primaryContrast',
    p: 1.5,
    borderRadius: 2,
  },
  arrow: {
    color: 'utils.gray950',
  },
}
